import { t } from 'i18next'
import React, { useContext, useEffect, useState } from 'react'
import { FormGroup, Input, Spinner } from 'reactstrap'
import { ButtonBlue } from '../../Buttons/ButtonBlue'
import { ButtonWhite } from '../../Buttons/ButtonWhite'
import EquipmentOrToolsTypesContext from '../../../context/EquipmentOrToolsTypes/EquipmentOrToolsTypesContext'
import { useNavigate, useParams } from 'react-router-dom'
import { AlertModal } from '../AlertModal'
import successIcon from '../../../assets/icons/equiptment-success.icon.svg'
import errorIcon from '../../../assets/icons/equiptment-error-icon.svg'

export const EquipmentOrToolsTypesCreateOrEdit = () => {

  const { equipmentOrToolId } = useParams();

  const isEdit = equipmentOrToolId !== undefined

  const { equipmentOrToolsTypesState, createType, clean, setError, getEquipmentOrToolType, editType } = useContext(EquipmentOrToolsTypesContext);

  const { type, error, alert, errorMessage, alertMessage, isSending } = equipmentOrToolsTypesState;

  const [formState, setFormState] = useState(type);

  const { equipmentDescription = '', equipmentEnabled = true } = formState;

  const navigate = useNavigate();

  const disabled = equipmentDescription.trim().length === 0;

  const getBack = () => {
    clean();
    navigate(-1);
  }

  const handleChange = ({ target }) => {
    const { name, value } = target;
    setFormState({
      ...formState,
      [name]: value
    });
  }

  const onSubmit = (e) => {
    e.preventDefault();
    if (disabled) return
    if (isEdit) {
      editType(formState)
    } else {
      createType(formState)
    }
  }

  useEffect(() => {
    if (isEdit) {
      getEquipmentOrToolType(equipmentOrToolId)
    }
    // eslint-disable-next-line
  }, [isEdit])


  useEffect(() => {
    setFormState(type)
  }, [type])

  return (
    <>
      {alert && (
        <AlertModal
          showModal={alert}
          icon={successIcon}
          onClose={getBack}
          message={alertMessage}
        />
      )}

      {error && (
        <AlertModal
          showModal={error}
          icon={errorIcon}
          onClose={() => setError(false)}
          message={errorMessage}
        />
      )}

      <div className='h-100 ms-sm-0 me-sm-0 ms-3 me-3'>
        <form
          className='d-flex flex-column justify-content-between h-100 pb-5'
          onSubmit={onSubmit}
        >
          <div>
            <div className='mb-3'>
              <label
                htmlFor="equipmentDescription"
                className='titlelabel-filter'
              >
                {t('NAME')}
              </label>
              <input
                name="equipmentDescription"
                className='form-control'
                type="text"
                onChange={handleChange}
                value={equipmentDescription}
              />
            </div>

            <div
              className='p-2 d-flex justify-content-between align-items-center'
              style={{ backgroundColor: '#FFFFFF', borderRadius: '5px' }}
            >
              <label
                htmlFor='equipmentEnabled'
                className='titlelabel-filter'
              >
                {Boolean(equipmentEnabled) ? t('ENABLED') : t('NOT_ENABLED')}
              </label>
              <FormGroup switch>
                <Input
                  type="switch"
                  name='equipmentEnabled'
                  checked={equipmentEnabled}
                  value={equipmentEnabled}
                  onChange={(e) => handleChange({
                    target: {
                      name: e.target.name,
                      value: e.target.value === "true" ? false : true
                    }
                  })}
                />
              </FormGroup>
            </div>
          </div>

          <div className={`d-flex justify-content-${isSending ? 'center' : 'around'} align-items-center pb-5`}>
            {
              isSending ?
                <Spinner />
                :
                <>
                  <div>
                    <ButtonWhite
                      className='text-dark shadow-none'
                      onClick={getBack}
                    >
                      {t('CANCEL')}

                    </ButtonWhite>
                  </div>

                  <div>
                    <ButtonBlue
                      type='submit'
                      // onClick={handleSubmit}
                      disabled={disabled}
                    >
                      {t('SAVE')}
                    </ButtonBlue>
                  </div>
                </>
            }
          </div>

        </form >
      </div >
    </>
  )
}
